<template>
  <div class="hp-manager-page-list">
    <filter-from :filter='filter' @handleSubmit="handleSubmit">
    </filter-from>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a @click="selected(rowKey.data)">选择</a>
        </span>
      </template>
    </standard-table>
  </div>
</template>


<script>
import { api } from "@/common";
import filterFrom from "@/components/filter/filter";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  // name: "hp-manager-page-dealer-select",
  mixins: [account, dateFormat, moneyFormat],
  components: {
    filterFrom
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "name",
          name: "名称"
        },
        {
          type: "input",
          key: "code",
          name: "编码"
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 70,
          scopedSlots: { customRender: "action" },
          fixed: "left"
        },
        {
          title: "名称",
          dataIndex: "name",
          //width: 130,
          sorter: true
        },
        {
          title: "编码",
          dataIndex: "code",
          width: 120,
          sorter: true
        },
        {
          title: "联系电话",
          dataIndex: "telephone",
          width: 100,
          sorter: true
        },
        {
          title: "客户类别",
          dataIndex: "dealerType",
          sorter: true,
          width: 200,
          customRender: (text, row, index) => {
            return row.dealerTypeName;
          }
        },
        {
          title: "客户分组",
          dataIndex: "groupName",
          width: 200
        }
      ],
      datas: [],
      filterdata: Object.assign(
        { name: "", isActive: true },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions
    };
  },
  async mounted() {
    this.getDatas(this.filterdata);
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.name = p.values.name;
      this.filterdata.code = p.values.code;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },

    selected(record) {
      this.$emit("getSelectedDealer", record);
    },

    refreshCurrent() {
      this.pagination.current = 0;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetDealerSelectList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/router/Basic/Dealer/SelectList.vue